/**
 * Emergency Protocol meters (Global / Zone / Target).
 * Authoritative target: `config/exploreUnknownBattleBonuses.json` → bonuses.*.collectParts.targetParts
 */
export const EXPLORE_UNKNOWN_EP_TARGET_PARTS = 3;

/** @typedef {'global' | 'zone' | 'target'} ExploreUnknownEpVariant */

/**
 * @type {ReadonlyArray<{
 *   id: 'epGlobal' | 'epZone' | 'epTarget',
 *   gameStatePartsKey: string,
 *   gameStateChargesKey: string,
 *   apiKeyParts: string,
 *   apiKeyCharges: string,
 *   image: string,
 *   variant: ExploreUnknownEpVariant,
 *   i18nKey: string,
 *   spendActionType: string,
 *   devSpawnActionType: string,
 * }>}
 */
export const EXPLORE_UNKNOWN_EP_METERS = Object.freeze([
  {
    id: 'epGlobal',
    gameStatePartsKey: 'exploreUnknownEpGlobalPartsCollected',
    gameStateChargesKey: 'exploreUnknownEpGlobalCharges',
    apiKeyParts: 'epGlobalPartsCollected',
    apiKeyCharges: 'epGlobalCharges',
    image: '/images/ep_board.jpg',
    variant: 'global',
    i18nKey: 'epGlobal',
    spendActionType: 'useExploreUnknownEpGlobal',
    devSpawnActionType: 'devSpawnExploreUnknownEpGlobal',
  },
  {
    id: 'epZone',
    gameStatePartsKey: 'exploreUnknownEpZonePartsCollected',
    gameStateChargesKey: 'exploreUnknownEpZoneCharges',
    apiKeyParts: 'epZonePartsCollected',
    apiKeyCharges: 'epZoneCharges',
    image: '/images/ep_zone.jpg',
    variant: 'zone',
    i18nKey: 'epZone',
    spendActionType: 'useExploreUnknownEpZone',
    devSpawnActionType: 'devSpawnExploreUnknownEpZone',
  },
  {
    id: 'epTarget',
    gameStatePartsKey: 'exploreUnknownEpTargetPartsCollected',
    gameStateChargesKey: 'exploreUnknownEpTargetCharges',
    apiKeyParts: 'epTargetPartsCollected',
    apiKeyCharges: 'epTargetCharges',
    image: '/images/ep_single.jpg',
    variant: 'target',
    i18nKey: 'epTarget',
    spendActionType: 'useExploreUnknownEpTarget',
    devSpawnActionType: 'devSpawnExploreUnknownEpTarget',
  },
]);
